import axios from "axios"
import {  useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { MANAGE_CUSTOMER } from "../../../../../Utilities/APIs/APIs"
import Modal from "../../../../Partials/Elements/Modal/Modal"
import ViewButton from "../../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDButtons/ViewButton/ViewButton"
import CRUDTable from "../../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTable"
import ShortTextCell from "../../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableCells/ShortTextCell/ShortTextCell"
import CRUDTableHeader from "../../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableHeader/CRUDTableHeader"
import CRUDth from "../../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableHeader/CRUDth/CRUDth"
import CRUDTableRow from "../../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableRow/CRUDTableRow"

import useAxiosInstance from "../../../../../Utilities/Hooks/useAxiosInstance"

function WishlistFromCustomer() {

    const [wishlists , setWishlists] = useState(null)
    console.log(wishlists);
    const [showModal, setShowModal] = useState(false)
    const [targetID, setTargetID] = useState(null)
    const [showViewSection, setShowViewSection] = useState(false)

    const axiosInstance = useAxiosInstance()

    const {customerID} = useParams()

    useEffect(() => {

        async function fetchAndSetsetWishlists() {
            const {data} = await axiosInstance.get(MANAGE_CUSTOMER + 'getWishlistsForSingleCustomer/' + customerID)
            setWishlists(data)
        }
        fetchAndSetsetWishlists()

    }, [ customerID])

    function handleClose() {
        setShowModal(false);
        setShowViewSection(false);
    }

    return (
        <>
            <div className='crud_holder'>
                <div className="body_header">
                    <h1 className="heading">{`Wishlists (${wishlists?.length} in total)`}</h1>
                </div>
                <CRUDTable>
                    <CRUDTableHeader>
                        <CRUDth th= ' Name' />
                        {/* <CRUDth th= 'Address Type' /> */}
                        <CRUDth th= 'Actions' />
                    </CRUDTableHeader>
                    <tbody>
                        {wishlists?.map(wishlist => (
                            <CRUDTableRow key={wishlist._id}>
                                <ShortTextCell text={wishlist.name} />
                                {/* <ShortTextCell text={wishlist.type} /> */}
                                <td className="action_button_cell">
                                    <ViewButton
                                    setShowModal={setShowModal}
                                    setShowViewSection={setShowViewSection}
                                    targetID={wishlist._id}
                                    setTargetID={setTargetID}
                                    />
                                </td>
                            </CRUDTableRow>
                        ))}
                    </tbody>
                </CRUDTable>
            </div>
            {showModal && 
                <Modal
                    handleClose={handleClose}
                    modalHeading={
                        (showViewSection && `View Address`)
                    }
                >
                       
                </Modal>
            }
        </>
    )
}

export default WishlistFromCustomer